import { useEffect } from 'react';

import { Login } from '@/shared/features/auth/components/login/login';
import { clearStorageKeepingPreferences } from '@/shared/utils/storage/storage-keys';

export const LoginRoute = () => {
  // This is a workaround for a bug, that prevents the user from logging into our plattform
  // Before this, the user had to clear his application storage manually and refresh the page
  // With automatically clearing it, when navigating to the /auth/login route, we expect this
  // to be fixed
  useEffect(() => {
    clearStorageKeepingPreferences();
    sessionStorage.clear();

    // Clear all accessible cookies
    document.cookie.split(';').forEach((cookie) => {
      const eqPos = cookie.indexOf('=');
      const name =
        eqPos > -1 ? cookie.substring(0, eqPos).trim() : cookie.trim();
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
    });
  }, []);

  return <Login />;
};
